module.exports = __webpack_public_path__ + "static/media/roadmpap-5.613c068f.png";